import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { waitForSeconds } from "../../../helper";
import { restartQuiz } from "../formHelper";

export default function CompletedDrivers({}) {
  const navigate = useNavigate();
  const [results, setResults] = useState();

  useEffect(() => {
    let res = formatReponsesDrivers(JSON.parse(localStorage.getItem("reponses")));
    setResults(res);
    showReponses();
  }, []);

  async function showReponses() {
    await waitForSeconds(0.2);
    document.getElementById("title").classList.remove("opacity-0");

    await waitForSeconds(1);
    document.getElementById("subtitle").classList.remove("opacity-0");
    document.getElementById("subtitle").classList.add("mt-10");

    document.getElementById("results_card").classList.remove("opacity-0");
    document.getElementById("results_card").classList.add("mt-10");

    await waitForSeconds(1);
    document.getElementById("res_0").classList.remove("opacity-0");
    document.getElementById("res_0_circle").classList.remove("skew-x-6");
    document.getElementById("res_0_circle").classList.remove("skew-y-12");

    await waitForSeconds(1);
    for (let index = 1; index < 5; index++) {
      await waitForSeconds(0.1);
      document.getElementById("res_" + index + "").classList.remove("opacity-0");
      document.getElementById("res_" + index + "_circle").classList.remove("skew-x-6");
      document.getElementById("res_" + index + "_circle").classList.remove("skew-y-12");
    }
    await waitForSeconds(1.5);
    document.getElementById("button_restart").classList.remove("opacity-0");
  }

  return (
    <div className="flex flex-col justify-center items-center text-center pb-20 p-5">
      <img id="logo" src="/images/Page_résultats.png" className="mx-auto h-52 md:h-64 transition-all duration-1000 ease-out" alt="logo" />
      <h1 id="title" className="opacity-0 transition-all duration-1000 ease-out lg:text-5xl">
        Merci d'avoir rempli le formulaire
      </h1>
      {/*<p id="subtitle" className="opacity-0 transition-all duration-700 ease-out lg:text-xl">*/}
      {/*  Voici vos résultats*/}
      {/*</p>*/}
      {/*{results && (*/}
      {/*  <div*/}
      {/*    id="results_card"*/}
      {/*    className="opacity-0 transition-all duration-1000 ease-out w-full h-full max-w-2xl bg-white flex flex-col space-y-5 p-5 rounded-lg shadow-xl"*/}
      {/*  >*/}
      {/*    <div id="res_0" className="opacity-0  transition-all duration-1000 ease-out flex flex-col items-center w-full space-y-2 text-xl lg:text-2xl">*/}
      {/*      <div*/}
      {/*        id="res_0_circle"*/}
      {/*        className="rounded-full w-16 h-16 flex items-center transition-all duration-1000 ease-out justify-center skew-x-6 skew-y-12 bg-palette-green text-white font-bold"*/}
      {/*      >*/}
      {/*        {results[0].score}*/}
      {/*      </div>*/}
      {/*      <p id="res_0_text" className="text-center font-semibold">*/}
      {/*        {results[0].group}*/}
      {/*      </p>*/}
      {/*    </div>*/}
      {/*    <hr />*/}
      {/*    {results.map((e, k) =>*/}
      {/*      k === 0 ? (*/}
      {/*        <></>*/}
      {/*      ) : (*/}
      {/*        <div id={"res_" + k} className="flex opacity-0  items-center w-full space-x-2 md:px-8 transition-all duration-700 ease-out">*/}
      {/*          <div*/}
      {/*            id={"res_" + k + "_circle"}*/}
      {/*            className="rounded-full w-12 h-12 flex items-center transition-all duration-700 ease-out skew-x-6 skew-y-12 text-sm md:text-lg justify-center border-2 border-palette-green font-bold"*/}
      {/*          >*/}
      {/*            {e.score}*/}
      {/*          </div>*/}
      {/*          <p className="text-center font-semibold">{e.group}</p>*/}
      {/*        </div>*/}
      {/*      )*/}
      {/*    )}*/}
      {/*  </div>*/}
      {/*)}*/}
      <button
        id="button_restart"
        onClick={()=>restartQuiz(navigate)}
        className="font-semibold opacity-0 transition-all duration-700 ease-out border flex items-center space-x-1 mt-20 border-palette-green mx-auto text-palette-green rounded-lg px-4 py-1.5"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 00-3.7-3.7 48.678 48.678 0 00-7.324 0 4.006 4.006 0 00-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3l-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 003.7 3.7 48.656 48.656 0 007.324 0 4.006 4.006 0 003.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3l-3 3"
          />
        </svg>
        <p>Refaire le quiz</p>
      </button>
    </div>
  );
}

export function formatReponsesDrivers(reponses) {
  let res = [];
  for (let index = 0; index < reponses.length; index++) {
    const group = reponses[index];
    for (let i = 0; i < group.length; i++) {
      const reponse = group[i];
      if (!res.find((e) => e.group === reponse.scoreGroup)) res.push({ group: reponse.scoreGroup, score: reponse.score });
      else res.find((e) => e.group === reponse.scoreGroup).score += reponse.score;
    }
  }
  res.sort((a, b) => b.score - a.score);
  return res;
}
